import { AVATAR_DEFAULT_URL } from '~/rails_assets';

export function avatarUrlForStyle(avatarData, style) {
  let url = null;

  if (typeof avatarData === 'string') {
    url = avatarData;
  } else if (avatarData && typeof avatarData === 'object') {
    if (style === 'medium') {
      style = 'thumb';
    }

    url = avatarData[style] || avatarData.normal || avatarData.speck;
  }

  if (!url) {
    url = AVATAR_DEFAULT_URL[style];
  }

  return url;
}

export function dimensionsForStyle(style) {
  switch (style) {
    case 'speck':
      return 25;
    case 'medium':
      return 32;
    case 'thumb':
      return 50;
    case 'normal':
      return 150;
  }
}
